/* eslint-disable no-param-reassign */
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import get from 'lodash/get';

import auth from './auth';
import board from './board';
import chatConnection from './chatConnection';
import circles from './circles';
import context from './context';
import data from './data';
import invitations from './invitations';
import profiles from './profiles';
import programs from './programs';
import surveys from './surveys';
import ui from './ui';
import communities from './communities';
import common from './common';
import complaints from './complaints';
import dependentForm from './dependentForm';
import teams from './teams';
import dependentManagement from './dependentManagement';
import appointmentForm from './appointmentForm';
import paymentMethods from './payment-methods';
import guarantorsInformation from './guarantor-information';
import dashboard from './dashboard';
import healthboard from './healthboard';
import schedule from './schedule';
import appointments from './appointmnents/appointment-details-req';
import paperwork from './paperwork';
import managePatientInsurances from './manage-insurances';
import appointmentsState from './appointmnents';
import { createActions, createConsts } from '../utils/redux';

import { consts as logout } from './auth/logout';

export const loginReferrerConsts = createConsts(
  'auth',
  'routing',
  'SET_LOGIN_REFERRER',
  'CLEAR_LOGIN_REFERRER',
);
export const loginReferrerActions = createActions(loginReferrerConsts);

/*
 As we use third party router reducer, we need to have an
 ability to pass there previous routing substate
 even if we cleen up all our store due to logout.
 */
let __state; // Entire state
const _routerReducer = (state, action) => {
  if (action.type === logout.CLEAR) {
    state = __state.routing;
  }

  // Return back to referrer page after login.s
  switch (action.type) {
    case loginReferrerConsts.SET_LOGIN_REFERRER:
      return {
        ...state,
        loginReferrer: action.payload.referrer,
      };
    case loginReferrerConsts.CLEAR_LOGIN_REFERRER:
      return {
        ...state,
        loginReferrer: null,
      };
    default:
      return routerReducer(state, action);
  }
};

export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    appointmentForm,
    paymentMethods,
    guarantorsInformation,
    appointments,
    appointmentsState,
    auth,
    board,
    chatConnection,
    circles,
    common,
    communities,
    complaints,
    context,
    dashboard,
    data,
    dependentForm,
    dependentManagement,
    healthboard,
    invitations,
    profiles,
    programs,
    routing: _routerReducer,
    schedule,
    surveys,
    teams,
    ui,
    paperwork,
    managePatientInsurances,
    ...injectedReducers,
  });

  return (state, action) => {
    if (get(action, 'type') === logout.CLEAR) {
      __state = state;
      state = undefined;
    }

    return rootReducer(state, action);
  };
}



// WEBPACK FOOTER //
// ./src/redux/reducers.js